//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
    isCreating: { type: Boolean, default: false },
    existingRanges: { type: Array, default: () => [] },
  },

  emits: ['save', 'create'],

  data() {
    return {
      formValid: true,
      payload: this.getEmptyPayload(),
      oldPayload: this.getEmptyPayload(),
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),

    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    fromRules() {
      return [
        (v) => {
          if (!this.payload) return true;
          if (this.payload.amountTo === 0 && v === 0) return true;
          if (v >= this.payload.amountTo && this.payload.amountTo !== null) {
            return this.$t('From must be less than To');
          }
          return true;
        },
      ];
    },
    toRules() {
      return [
        (v) => {
          if (!this.payload) return true;
          if (this.payload.amountTo === 0 && v === 0) return true;
          if (v <= this.payload.amountFrom && this.payload.amountFrom !== null) {
            return this.$t('To must be greater than From');
          }
          return true;
        },
        (v) => {
          if (!this.payload) return true;
          if (this.payload.amountFrom !== null
            && this.isRangeOverlapping(this.payload.amountFrom, v)) {
            return this.$t('Range overlaps with existing range');
          }
          return true;
        },
      ];
    },
  },

  methods: {
    getEmptyPayload() {
      return {
        amountFrom: null,
        amountTo: null,
        merchantFee: null,
        traderProfit: null,
      };
    },

    isRangeOverlapping(newFrom, newTo) {
      if (
        !this.isCreating
        && this.payload.amountFrom === newFrom
        && this.payload.amountTo === newTo) {
        return false;
      }

      if (newFrom === null || newTo === null || newFrom >= newTo) {
        return false;
      }

      const [minExisting, maxExisting] = this.existingRanges;

      return newFrom < maxExisting && newTo > minExisting;
    },

    handleClose() {
      this.model = false;
    },
    handleSave() {
      this.formValid = this.$refs.form.validate();
      if (!this.formValid) return;

      this.handleClose();
      this.$emit('save', {
        payload: this.payload,
        type: this.data.type,
      });
    },
    handleCreate() {
      this.formValid = this.$refs.form.validate();
      if (!this.formValid) return;

      this.handleClose();
      this.$emit('create', {
        payload: this.payload,
        type: this.data.type,
      });
    },
  },

  watch: {
    data(value) {
      if (!this.$props.isCreating) {
        this.payload = {
          amountFrom: value?.amountFrom ?? null,
          amountTo: value?.amountTo ?? null,
          merchantFee: value?.merchantFee ?? null,
          traderProfit: value?.traderProfit ?? null,
        };

        this.oldPayload = this.payload;
      }
    },
    value(value) {
      if (!value) this.payload = this.getEmptyPayload();

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    'payload.amountFrom': {
      handler() {
        if (this.payload.amountFrom === null) return;
        this.$nextTick(() => {
          if (this.$refs.form) {
            const isValid = this.$refs.form.validate();
            this.formValid = isValid;
          }
        });
      },
    },
    'payload.amountTo': {
      handler() {
        if (this.payload.amountTo === null) return;
        this.$nextTick(() => {
          if (this.$refs.form) {
            const isValid = this.$refs.form.validate();
            this.formValid = isValid;
          }
        });
      },
    },
  },
};
